import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AuthUser } from '@enroller/utils';
import { getConfig } from '../utils/config';
import { setSentryUser } from '../utils/sentry';

export const useSentry = () => {
  const { user } = useAuth0<AuthUser>();
  const { environment, sentryDsn } = getConfig();

  useEffect(() => {
    if (environment === 'local' || !user || !sentryDsn) {
      return;
    }

    setSentryUser(user);
  }, [environment, sentryDsn, user]);
};
